import { render, staticRenderFns } from "./MessageBoxnew.vue?vue&type=template&id=41d801d7&scoped=true&"
import script from "./MessageBoxnew.vue?vue&type=script&lang=js&"
export * from "./MessageBoxnew.vue?vue&type=script&lang=js&"
import style0 from "./MessageBoxnew.vue?vue&type=style&index=0&id=41d801d7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d801d7",
  null
  
)

export default component.exports